"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calcChecksumBmwFast = calcChecksumBmwFast;
function calcChecksumBmwFast(data, offset, length) {
    let sum = 0;
    for (let i = 0; i < length; i += 1) {
        sum = (sum + data[offset + i]) & 0xff;
    }
    return sum;
}
//# sourceMappingURL=checksum.js.map